var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-render',{ref:"tableRender",attrs:{"config":_vm.config,"height":"52vh"}})}
var staticRenderFns = []

export { render, staticRenderFns }